export default __webpack_public_path__ + "static/timeline-06-c33a18723e0fe4bdc64287cfa3bef4fc.svg";